 //导入 axios
//  import axios from 'axios';
import axiosRequest from '@/utils/axios-default-request';


 //配置 axios 接口

 /** 客户端 */

 /**
  *   客户端注册验证码
  * @param {*} data  ==> loginName 账号
  * @returns {msg,data,code}
  */
let xqregisterActiveCode = (data) =>axiosRequest.postBody('/clientinterface/registerActiveCode',data);
 
 /**
  *   客户端注册
  * @param {*} data  ==> loginName 账号;  password 密码; yzm 验证码;
  * @returns {msg,data,code}
  */
  let xqregister = (data) =>axiosRequest.postBody('/clientinterface/register',data);

 /**
  *   客户端登录验证码
  * @param {*} data  ==> loginName 账号;
  * @returns {msg,data,code}
  */
  let xqloginActiveCode = (data) =>axiosRequest.postBody('/clientinterface/loginActiveCode',data);

  /**
  *   客户端登录
  * @param {*} data  ==> loginName 账号;  password 密码/yzm 验证码; 
  * @returns {msg,data,code} 
  * data => userId 用户id;   clientCurrentAccount 当前登录的账号;    loginName 登录账号;
  * email 邮箱账号;  phonenumber 手机号码;   avatar 头像;
  */
   let xqlogin = (data) =>axiosRequest.postBody('/clientinterface/login',data);

 /**
  *   客户端忘记密码验证码
  * @param {*} data  ==> loginName 账号;
  * @returns {msg,data,code} => loginName  账号;   password 密码; yzm 验证码;
  */
  let xqresetPassActiveCode = (data) =>axiosRequest.postBody('/clientinterface/resetPassActiveCode',data);

   /**
  *   客户端忘记密码接口
  * @param {*} data  ==> loginName 账号;
  * @returns {msg,data,code}
  */
    let xqresetPassword = (data) =>axiosRequest.postBody('/clientinterface/resetPassword',data);




 /**  译员端  */

 //注册验证码
let registerCode = (data) =>axiosRequest.postBody('/supinterface/registerActiveCode',data);

// 注册账号
let register = (data)=>axiosRequest.postBody('/supinterface/register',data);

//登录验证码
let loginCode = (data)=>axiosRequest.postBody('/supinterface/loginActiveCode',data);

//登录
let login = (data)=>axiosRequest.postBody('/supinterface/login',data);

//退出登录
let loginOut = (data)=>axiosRequest.postBody('/supinterface/loginOut',data);

//忘记密码验证码
let forgetPasswordCode = (data)=>axiosRequest.postBody('/supinterface/resetPassActiveCode',data);

//忘记密码
let forgetPassword = (data)=>axiosRequest.postBody('/supinterface/resetPassword',data);

// 获取笔译/口译数据
let getRWDTProjectList = (data)=>axiosRequest.postBodyJson('/supinterface/getProjectReleaseInforList',data);

// 获取当前
let getWsgrxxtx = (data)=>axiosRequest.postBody('/clientinterface/getWsgrxxtx',data)

// 调取接口进行登陆操作(传递端口号post)
let selectIdentity = (data)=>axiosRequest.postBody('/supinterface/selectIdentity',data)

// 切换当前状态译员端/客户端(传递端口号post)
let switchIdentity = (data)=>axiosRequest.postBody('/supinterface/switchIdentity',data)

// 获取微信小程序地址
let getURLScheme = (data)=>axiosRequest.postBody('/appletInterface/getURLScheme',data)

//数据板块
//新增访问人数
let getAddFWRS = (data)=>axiosRequest.postBody('/supinterface/getAddFWRS',data);

 export default {
   // 登录--传递端口
   selectIdentity,
   switchIdentity,//切换当前状态
   // 需求端 / 客户端
   xqregisterActiveCode,//客户端注册验证码
   xqregister,//客户端注册
   xqloginActiveCode,//客户端登录验证码
   xqlogin,//客户端登录
   xqresetPassActiveCode,//客户端忘记密码验证码
   xqresetPassword,//客户端忘记密码

   // 译员端
    registerCode,//注册验证码
    register,//注册
    loginCode,//登录验证码
    login,//登录
    loginOut,//退出登录
    forgetPasswordCode,//忘记密码验证码
    forgetPassword,//忘记密码

    getRWDTProjectList,//笔译口译
    getWsgrxxtx,//查询完善个人信息接口

    getURLScheme,//获取跳转微信小程序地址
    getAddFWRS,
 }